export default __webpack_public_path__ + "cc66398567aacd9717681d9ee91cb4f4.png";